import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

const SectionPurchaseProtection = () => (
  <div className="bg-gray-100 border border-gray-200 py-3 px-4 rounded-lg mb-3 lg:mb-4">
    <div className="my-0 mb-3 text-lg font-semibold text-gray-700 leading-tight text-md">
      <FormattedMessage id="SectionShippingPolicy.purchaseProtectionTitle" />
    </div>
    <div className="my-0 mb-3 text-lg font-normal text-gray-700 leading-tight text-sm">
      <FormattedMessage id="SectionShippingPolicy.purchaseProtectionDescription" />
      <a href="/p/disputes-policy" className="ml-2 text-sm no-underline font-medium hover:underline hover:text-gray-700">
        <FormattedMessage id="SectionShippingPolicy.viewMoreDetails" />
      </a>
    </div>
  </div>
);

export default SectionPurchaseProtection;
